import { TokenService } from '@processo/services/token.service';
import { AuthService } from '../authentication/auth.service';
import { TabSessionService } from '../authentication/tab-session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { logAuthEvent, describeHttpError } from './auth-diag.util';

export function appInitializer(
  tokenService: TokenService,
  authService: AuthService,
  router:Router,
  tabSession: TabSessionService
) {
  const refresh_token: any = localStorage.getItem('refresh_token');
  const urlParams = new URLSearchParams(window.location.search);
  const form_id = urlParams.get('form_id');
  const hasRefreshToken = !!(
    refresh_token &&
    refresh_token != '' &&
    refresh_token != 'undefined'
  );
  // If hasRefreshToken is false on a launch right after the user was logged
  // in, something outside the app (device/MDM policy, browser data cleanup)
  // erased localStorage — the app never got a chance to refresh.
  logAuthEvent('app-launch', {
    hasRefreshToken,
    path: `${window.location.pathname}${window.location.search}`.slice(0, 200),
    online: typeof navigator !== 'undefined' ? navigator.onLine : null,
  });
  if (form_id) {
    localStorage.removeItem('refresh_token');
    return () => Promise.resolve(true);
  }
  // A tab parked on the hand-off screen must not claim the session back when it
  // reloads — it is sitting there precisely because another tab owns it.
  if (window.location.pathname === '/session-moved') {
    return () => Promise.resolve(true);
  }
  return async () => {
    if (!hasRefreshToken) {
      await new Promise((resolve) => setTimeout(resolve, 300));
      return;
    }

    // Claim the session before spending a refresh-token rotation. Any older tab
    // stands down when it sees this claim, and if a newer tab out-claims us we
    // skip the refresh entirely — rotating here would invalidate the token the
    // winning tab is about to use. AppComponent handles the redirect.
    const isOwner = await tabSession.claimAndSettle();
    if (!isOwner) {
      logAuthEvent('tab-displaced-at-launch');
      return;
    }

    try {
      await firstValueFrom(authService.updateToken());
      logAuthEvent('appinit-refresh-ok');
    } catch (err) {
      logAuthEvent('appinit-refresh-failed', describeHttpError(err));
      return;
    }

    const noRedirectPaths = ['/login', '/contact-us', '/delete-account', '/register', '/registernew', '/forgot-password', '/registernew/additional-details','/registernew/verify-account'];

    // Use pathname only — `/login?redirect=...` must still count as login,
    // otherwise a valid session keeps bouncing into /loading.
    const currentPathname = window.location.pathname;

    if (currentPathname !== '/loading' && !noRedirectPaths.includes(currentPathname)) {
      router.navigate(['/loading'], {
        queryParams: {
          redirect: `${window.location.pathname}${window.location.search}`
        }
      });
    }
  };
}
